<template>
  <div>
    <div class="clearfix">
      <div class="float-left">
        <strong class="font-weight-bold">{{comment.writer.name}}</strong>
        <small class="grey-text"><mdb-icon icon="clock" class="ml-4" />{{$strDate(comment.regDate)}}</small>
      </div>
      <!-- 내가 작성한 글이 아닌 경우 -->
      <div class="float-right" v-if="!isOwner">
        <div v-if="!reply" class="text-right">
          <mdb-btn icon="edit" class="px-2 py-1" @click="reply = true"> 댓글</mdb-btn>
        </div>
      </div>
      <!-- 내가 작성한 글인 경우 -->
      <div v-else class="text-right">
        <!-- VIEW 모드 -->
        <span v-if="mode === 'VIEW'" >
          <mdb-btn icon="edit" class="px-2 py-1" @click="onEdit()"> 수정</mdb-btn>
          <mdb-btn icon="times" class="px-2 py-1" @click="onRemove" color="danger"> 삭제</mdb-btn>
        </span>
        <!-- Edit 모드 -->
        <span v-if="mode === 'EDIT'" >
          <mdb-btn icon="check" class="px-2 py-1" @click="onUpdate()"> 저장</mdb-btn>
          <mdb-btn icon="undo" class="px-2 py-1"  @click="onCancel()"> 취소</mdb-btn>
        </span>
      </div>
    </div>

    <pre v-if="mode=='VIEW'" class="my-1">{{comment.content}}</pre>
    <mdb-input v-else outline type="textarea" :rows="3" v-model="newContent"/>
    <!-- 댓글 -->
    <reply-write v-if="isLogin && reply" class="ml-5" :comment="comment" @add-reply="onAddReply" @cancel-reply="reply = false"/>
    <reply-list class="ml-5 my-3" :replies="comment.replies" :commentId="comment._id"/>
    <hr/>
  </div>
</template>
<script>
import { mdbIcon, mdbBtn, mdbInput } from 'mdbvue';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import ActionType from '@/store/modules/article/ActionType.js';
import replyList from './ReplyList';
import replyWrite from './ReplyWrite.vue';
export default {
  name: 'Comment',
  components: { mdbIcon, mdbBtn, mdbInput, replyList, replyWrite },
  props: ['comment', 'articleId', 'replyWrite'],
  data: () => ({
    mode: 'VIEW',
    reply: false,
    newContent: ''
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapGetters('auth', ['isLogin']),
    isOwner () {
      return this.comment.writer._id === this.profile._id
    }
  },
  methods: {
    // ...mapActions('article', [ActionType.ARTICLE_DELETE_COMMENT, ActionType.ARTICLE_UPDATE_COMMENT]),
    onEdit () {
      this.mode = 'EDIT'
      this.newContent = this.comment.content;
    },
    async onUpdate () {
      if (!confirm('저장할까요?')) {
        return;
      }
      this.comment.content = this.newContent
      await this.comment.save()
      this.newContent = '';
      this.mode = 'VIEW';
    },
    onCancel () {
      this.mode = 'VIEW'
      this.newContent = '';
    },
    onRemove () {
      if (!confirm('삭제할까요?')) return
      this.comment.delete()
      this.$emit('delete-comment', this.comment)
    },
    onAddReply (reply) {
      this.comment.replies.push(reply)
      this.reply = false;
    }
  }
}
</script>
